import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import ProductCard from '../components/ProductCard';
import SectionHeader from '../components/SectionHeader';
import Icon from '../../common/components/Icon';
import { ProductCardProps } from 'home/types/types';

interface ProductCarouselHeader {
  title?: string;
  linkLabel?: string;
  url?: string;
  icon?: 'none' | 'forbes';
}

const ProductCarousel = ({ products, header }: { products: ProductCardProps[]; header: ProductCarouselHeader }) => {
  const updateButtonVisibility = (swiper: any) => {
    const { isBeginning, isEnd } = swiper;
    const prevButton = document.querySelector('.products__button--prev');
    const nextButton = document.querySelector('.products__button--next');

    if (isEnd) {
      nextButton?.classList.add('carousel-button--hidden-2');
    } else {
      nextButton?.classList.remove('carousel-button--hidden-2');
    }

    if (isBeginning) {
      prevButton?.classList.add('carousel-button--hidden-2');
    } else {
      prevButton?.classList.remove('carousel-button--hidden-2');
    }
  };

  // TODO: Better modularity
  const icon = useMemo(() => {
    switch (header.icon) {
      case 'forbes':
        return (
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" fill="#020617" />
            <path
              d="M22 12.9083L21.2764 13.1417C20.6734 11.1 19.6482 9.93333 17.8392 9.93333H15.4874C15.3668 11.275 15.3065 13.4333 15.3668 15.7083L16.9347 15.65C18.0201 15.65 18.4422 14.8917 18.6834 13.725H19.2864V18.45H18.6834C18.4422 17.2833 17.9598 16.525 16.9347 16.4667H15.3668C15.3668 18.1583 15.3668 19.6167 15.4874 20.4917C15.608 21.775 15.9095 22.3 16.8744 22.4167L17.7186 22.475V23H10V22.475L10.6633 22.4167C11.5678 22.3 11.9296 21.7167 12.0503 20.4917C12.1709 18.3917 12.1709 14.0167 11.9899 11.5667C11.8693 10.2833 11.5075 9.75833 10.603 9.64167L10 9.58333V9H22V12.9083Z"
              fill="white"
            />
          </svg>
        );
    }
  }, [header.icon]);

  return (
    <div className="react-block__product-carousel">
      <div className="container">
        {header.title && (
          <SectionHeader
            title={header.title}
            url={header.url}
            linkLabel={header.linkLabel}
            hasPreIcon
            hasTitleLink
            iconComponent={icon}
          />
        )}
        <div className="react-block__carousel">
          <div className="carousel-button products__button--prev button button--primary button--large">
            <Icon name="ecom-chevron-left" size="small" />
          </div>
          <div className="carousel-button products__button--next button button--primary button--large">
            <Icon name="ecom-chevron-right" size="small" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="react-block__swiper"
            spaceBetween={30}
            slidesPerView={3}
            navigation={{
              nextEl: '.products__button--next',
              prevEl: '.products__button--prev',
            }}
            pagination={{ clickable: true, el: '.swiper-custom-pagination' }}
            scrollbar={false}
            onSwiper={(swiper: any) => {
              updateButtonVisibility(swiper);
            }}
            onSlideChange={(swiper: any) => {
              updateButtonVisibility(swiper);
            }}
            breakpoints={{
              320: { slidesPerView: 1.2 },
              768: { slidesPerView: 2.2 },
              991: { slidesPerView: 3 },
            }}
          >
            {products.map((product, index) => (
              <SwiperSlide key={index}>
                <ProductCard {...product} hideBrand disablePagination useSingleImage />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-custom-pagination" />
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
